import { RefreshCw, X } from 'lucide-react';
import { useState } from 'react';

import { Button } from '@/components/ui/button';
import useServiceWorkerUpdate from '@/hooks/useServiceWorkerUpdate';

const PwaUpdateToast = ({ variant = 'member' }) => {
  const { updateAvailable, applyUpdate } = useServiceWorkerUpdate();
  const [dismissed, setDismissed] = useState(false);

  if (!updateAvailable || dismissed) return null;

  const isAdmin = variant === 'admin';
  const color = isAdmin ? 'border-amber-500 bg-stone-950 text-amber-50' : 'border-[#9B1B30] bg-white text-stone-900 dark:bg-stone-900 dark:text-stone-50';

  return (
    <div className={`fixed bottom-20 right-4 z-[90] max-w-sm rounded-xl border shadow-2xl ${color}`} role="status" aria-live="polite">
      <div className="flex items-start gap-3 p-4">
        <RefreshCw className="h-5 w-5 mt-0.5 text-amber-500" />
        <div className="flex-1">
          <p className="font-semibold">Update available</p>
          <p className="text-sm opacity-80">Reload to get the latest Owaza portal.</p>
          <Button size="sm" className="mt-3 bg-[#9B1B30] hover:bg-[#7d1626] text-white" onClick={applyUpdate}>
            Reload now
          </Button>
        </div>
        <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss update notification" className="opacity-70 hover:opacity-100">
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};

export default PwaUpdateToast;
